import React from 'react';
import PropTypes from 'prop-types';
import './sitemap.m.css';

class Sitemap extends React.Component {
  render() {
    const parentSections = [];
    const childSections = [];
    this.props.data.sections.forEach(section => {
      if (!section['parent-id']) {
        parentSections.push(section);
      } else {
        childSections.push(section);
      }
    });
    parentSections.forEach(psection => {
      childSections.forEach(csection => {
        if (psection.id === csection['parent-id']) {
          psection.child = true;
        }
      });
    });
    childSections.forEach(psection => {
      let count = 0;
      childSections.forEach(csection => {
        if (psection.id === csection['parent-id']) {
          if (count === 0) {
            psection.child = true;
            parentSections.push(psection);
            count++;
          }
        }
      });
    });

    return (
      <div className="container">
        <h1 styleName="sitemap-header">Sitemap</h1>
        <div styleName="sitemap-container">
          <div styleName="section-with-subs-parent">
            {parentSections.map((psection, i) => {
              if (psection.child) {
                return (
                  <div styleName="section-with-subs-each" key={i}>
                    <h3 styleName="section-name">
                      <a href={psection.slug}>{psection['display-name']}</a>
                    </h3>
                    {childSections.map((csection, j) => {
                      if (psection.id === csection['parent-id']) {
                        return (
                          <h4 styleName="subsection-name" key={j}>
                            <a href={csection.slug}>{csection['display-name']}</a>
                          </h4>
                        );
                      }
                    })}
                  </div>
                );
              }
            })}
          </div>
          {parentSections.map((psection, i) => {
            if (!psection.child) {
              return (
                <h3 styleName="section-no-subs" key={i}>
                  <a href={psection.slug}>{psection['display-name']}</a>
                </h3>
              );
            }
          })}
          <h3 styleName="section-no-subs">
            <a href="/about-us"> About-us </a>
          </h3>
          <h3 styleName="section-no-subs">
            <a href="/privacy-policy"> Privacy Policy </a>
          </h3>
          <h3 styleName="section-no-subs">
            <a href="/terms-of-use"> Terms of use</a>
          </h3>
        </div>
      </div>
    );
  }
}

Sitemap.propTypes = {
  data: PropTypes.object.isRequired
};

export { Sitemap };
